import { httpGet } from "@/api/connection";
import { GetOrganizationsFn } from "./organizations.api.types";

const getOrganizations: GetOrganizationsFn = async () => {
  return await httpGet("/clients/organizations");
};

export const OrganizationsAPI = {
  get: getOrganizations,
};
